import React from 'react';
import { motion } from 'framer-motion';
const menuData = [{
  category: 'Starters',
  items: [{
    name: 'Wagyu Beef Carpaccio',
    description: 'Truffle aioli, shaved parmesan, crispy capers, micro arugula',
    price: '24'
  }, {
    name: 'Jumbo Lump Crab Cakes',
    description: 'Remoulade, roasted corn relish, chili oil',
    price: '28'
  }, {
    name: 'Oysters Rockefeller',
    description: 'Spinach, pernod, hollandaise, bacon breadcrumbs',
    price: '22'
  }]
}, {
  category: 'Entrées',
  items: [{
    name: 'Bone-In Ribeye',
    description: '22oz prime cut, roasted garlic herb butter, sea salt',
    price: '68'
  }, {
    name: 'Chilean Sea Bass',
    description: 'Miso glaze, baby bok choy, ginger dashi broth',
    price: '52'
  }, {
    name: 'Filet Mignon',
    description: '8oz center cut, truffle potato purée, wild mushroom demi-glace',
    price: '58'
  }]
}, {
  category: 'Craft Cocktails',
  items: [{
    name: 'The 211 Smoked Old Fashioned',
    description: 'Woodford Reserve, demerara, angostura, cherry wood smoke',
    price: '18'
  }, {
    name: 'Midnight Martini',
    description: 'Grey Goose, espresso, coffee liqueur, vanilla bean',
    price: '16'
  }, {
    name: 'Botanical Garden',
    description: "Hendrick's Gin, elderflower, cucumber, fresh lime, mint",
    price: '15'
  }]
}, {
  category: 'Desserts',
  items: [{
    name: 'Dark Chocolate Soufflé',
    description: 'Grand Marnier crème anglaise, fresh raspberries',
    price: '14'
  }, {
    name: 'Vanilla Bean Crème Brûlée',
    description: 'Caramelized sugar crust, seasonal berries',
    price: '12'
  }, {
    name: 'Artisan Cheese Board',
    description: "Chef's selection of cheeses, honeycomb, marcona almonds",
    price: '20'
  }]
}];
export function MenuHighlights() {
  return <section id="menu" className="py-32 px-6 bg-brand-charcoal relative border-y border-brand-gold/10" data-id="element-93">
      <div className="max-w-6xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-95">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-offwhite mb-6" data-id="element-96">
            Menu Highlights
          </h2>
          <div className="w-12 h-px bg-brand-gold mx-auto" data-id="element-97"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20" data-id="element-98">
          {menuData.map((section, sectionIdx) => <motion.div key={section.category} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: sectionIdx * 0.2
        }} data-id="element-99">
              <h3 className="font-serif text-2xl text-brand-gold mb-8 text-center uppercase tracking-widest" data-id="element-100">
                {section.category}
              </h3>
              <div className="space-y-8" data-id="element-101">
                {section.items.map((item, itemIdx) => <div key={itemIdx} className="flex flex-col" data-id="element-102">
                    <div className="flex justify-between items-baseline mb-2" data-id="element-103">
                      <h4 className="font-serif text-lg text-brand-offwhite tracking-wide" data-id="element-104">
                        {item.name}
                      </h4>
                      <div className="flex-grow border-b border-dotted border-brand-gold/30 mx-4 relative top-[-4px]" data-id="element-105"></div>
                      <span className="text-brand-gold font-serif text-lg" data-id="element-106">
                        {item.price}
                      </span>
                    </div>
                    <p className="text-sm text-brand-offwhite/50 italic" data-id="element-107">
                      {item.description}
                    </p>
                  </div>)}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-20 text-center" data-id="element-108">
          <a href="#contact" className="inline-block px-8 py-3 border border-brand-gold text-brand-gold text-sm tracking-widest uppercase hover:bg-brand-gold hover:text-brand-black transition-colors duration-300" data-id="element-109">
            View Full Menu In-House
          </a>
        </motion.div>
      </div>
    </section>;
}